"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMobileElementFingerprint = exports.createElementFingerprint = exports.buildElementDescriptor = void 0;
const crypto_1 = require("crypto");
const elementDescriptor_1 = require("./elementDescriptor");
Object.defineProperty(exports, "buildElementDescriptor", { enumerable: true, get: function () { return elementDescriptor_1.buildElementDescriptor; } });
const hash = (input) => (0, crypto_1.createHash)('sha256').update(input).digest('hex');
/** Groups findings by element; must stay out of `fingerprints`, which deduplication merges on. */
const createElementFingerprint = (input) => `${elementDescriptor_1.ELEMENT_FINGERPRINT_VERSION}:${hash((0, elementDescriptor_1.buildElementDescriptor)(input))}`;
exports.createElementFingerprint = createElementFingerprint;
/**
 * A mobile target is already an element fingerprint, and mobile `html` is
 * serialized view properties rather than markup, so only the target is hashed.
 */
const createMobileElementFingerprint = (target) => `${elementDescriptor_1.ELEMENT_FINGERPRINT_VERSION}:${hash(JSON.stringify(target))}`;
exports.createMobileElementFingerprint = createMobileElementFingerprint;
//# sourceMappingURL=createElementFingerprint.js.map